import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../constants'

import { DateCell } from './date-cell'

export const DatesRow = ({ dates }) => {
  return (
    <HeaderRowDate style={ { backgroundColor: '#FFFFFF', position: 'absolute', overflow: 'hidden', top: 0, right: 0, width: '100%', height: 50, display: 'flex', flexDirection: 'row' } }>
      <Date style={ { width: 200, paddingLeft: '2%', paddingTop: '1%' } }>Date</Date>
      <Wrapper style={ { backgroundColor: '#FFFFFF', flex: 1, overflow: 'hidden', display: 'flex', borderBottom: '2px' } }>
        {dates.map(date => (
          <DateCell key={ date } date={ date } />
        ))}
      </Wrapper>
    </HeaderRowDate>
  )
}

const HeaderRowDate = styled.div`
  border: solid #000000;
  border-width: 0px 0px 2px 0px;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`

const Date = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`

const Wrapper = styled.div`
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`



// WEBPACK FOOTER //
// ./src/components/calendar/vertical-table/dates-row.js